"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var clsx_1 = require("../../utils/clsx");
exports.default = (0, vue_1.defineComponent)({
    name: "AppHeader",
    methods: { clsx: clsx_1.clsx },
    data: function () {
        return {
            isMenuOpen: false
        };
    },
});
